export default __webpack_public_path__ + "static/media/illi4.e1058af1.png";